import React from 'react';
import { Zap, MessageSquare, Calendar } from 'lucide-react';
import PhasePageTemplate from './PhasePageTemplate';

const PhaseActivation = () => (
  <PhasePageTemplate
    phaseNumber="05"
    phaseName="The Activation Call"
    tagline="Three hours. You meet your agent for the first time, we build your first real workflows together, and you leave with something that's already working."
    heroImage="/images/generated/process-hero-activation.png"
    conceptImage="/images/generated/process-concept-activation.png"
    delivers={[
      {
        icon: <Zap className="w-6 h-6" />,
        title: 'A Live, Working Agent',
        desc: 'Your agent goes live on this call. Not a demo environment — your actual system, connected to your tools, responding to real requests.',
      },
      {
        icon: <MessageSquare className="w-6 h-6" />,
        title: 'Your First Real Workflows',
        desc: 'We build the workflows we identified on your Strategy Call. By the end of this session, your agent is already doing real work — not waiting for you to figure it out.',
      },
      {
        icon: <Calendar className="w-6 h-6" />,
        title: 'Access to Winning Wednesday',
        desc: 'A weekly live group session for active RoofClaw clients. Questions, new workflows, troubleshooting, and ongoing coaching — every week, no extra charge.',
      },
    ]}
    whyTitle="We don't hand you a manual and walk away."
    whyBody="The Activation Call is where your investment starts paying off. We don't end the session until your agent is doing real work. We walk you through your first conversations, connect your remote access, and build the specific workflows you described in your Strategy Call. Winning Wednesday continues that momentum — every week, active clients join a live group session to go deeper, ask questions, and share what's working. You're not on your own after delivery. That's by design."
    experienceTitle="Your first real conversation with your agent."
    experienceBody="By the time you're on this call, your agent already knows your business. This session is about making it work in practice — having your first real conversations, testing the workflows we designed for you, and making sure everything runs the way it should. We handle the technical setup on the call. You focus on learning to work with your new team member."
    experienceHighlights={[
      'First conversation with your agent — guided, not thrown in the deep end',
      'Remote access set up together so you can reach your agent from anywhere',
      'At least one complete workflow running before we end the call',
      'Winning Wednesday invite delivered — first session within the week',
    ]}
    timeline="3 hours"
    mockupImage="/images/generated/mockup-agent-chat.jpg"
    mockupCaption="Your agent in action — responding via Telegram, connected to your tools."
    todoItems={[
      'Show up with your machine plugged in',
      'Have your welcome package nearby',
      'Bring specific questions from your Strategy Call — we\'ll work through them live',
    ]}
    prevPhase={{ name: 'Secure Delivery', href: '/process/delivery' }}
    nextPhase={{ name: 'Ongoing Support', href: '/process/support' }}
  />
);

export default PhaseActivation;
